import React from 'react';
import { Form, Input, Modal, Button, Switch } from 'antd';
import { openNotification } from 'util/helpers';
import { useUpdateUserSceneAssetsMutation } from '@ozoneuniverse/ui-components/build-pkg/src/components/generated/graphql';

const notify = (type, msg, desc) => {
  openNotification(msg, desc, 'top', 2, type);
};

export function AddPOI({ selectedModel, open, setOpen }) {
  const [updateAsset] = useUpdateUserSceneAssetsMutation();

  const saveAsset = async () => {
    const res = await updateAsset({
      variables: {
        data: {
          metadata: {
            set: JSON.stringify(selectedModel.props.asset.metadata),
          },
        },
        where: {
          id: selectedModel.props.asset.id,
        },
      },
      refetchQueries: ['FindManyUserSceneAssets'],
    });

    if (res.errors || !res) {
      notify('error', 'Error', 'Something went wrong');
    } else {
      notify('success', 'Successfully', 'Saved POI');
    }
  };

  const onSave = async (values) => {
    const { desc, name, isTour } = values;

    if (!selectedModel.props.asset.metadata) {
      selectedModel.props.asset.metadata = {};
    }

    selectedModel.props.asset.metadata.poiData = {
      title: name,
      description: desc,
      isTour,
    };

    saveAsset();

    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onCancel={() => setOpen(false)}
      title='Create new Tour item'
      footer={false}
    >
      <Form layout='vertical' onFinish={onSave}>
        <Form.Item label='Name' required name='name'>
          <Input />
        </Form.Item>
        <Form.Item label='Description' required name='desc'>
          <Input.TextArea />
        </Form.Item>
        <Form.Item label='Show as Tour' required name='isTour'>
          <Switch />
        </Form.Item>
        <Button htmlType='submit' type='primary'>
          <span>Create</span>
        </Button>
      </Form>
    </Modal>
  );
}
